// extracted by mini-css-extract-plugin
module.exports = {"calculatorInit":"init_calculatorInit__xotH4"};